var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5005 2H14.5005V0.5C14.5005 0.223877 14.2766 0 14.0005 0C13.7244 0 13.5005 0.223877 13.5005 0.5V2H6.50049V0.5C6.50049 0.223877 6.27661 0 6.00049 0C5.72437 0 5.50049 0.223877 5.50049 0.5V2H2.5C1.11987 2.00146 0.0014648 3.11987 0 4.5V17.5C0.0014648 18.8801 1.11987 19.9985 2.5 20H17.5005C18.8807 19.9987 19.9992 18.8802 20.0005 17.5V4.5C19.9992 3.11981 18.8807 2.00128 17.5005 2ZM19.0005 17.5C18.9996 18.3281 18.3286 18.9991 17.5005 19H2.5C1.67194 18.9991 1.00092 18.3281 1 17.5V9H19.0005V17.5ZM19.0005 8H1V4.5C1.00092 3.67194 1.67194 3.00092 2.5 3H5.50049V4.5C5.50067 4.77594 5.72449 5.00018 6.00049 5C6.27643 4.99982 6.50067 4.776 6.50049 4.5V3H13.5005V4.5C13.5007 4.77594 13.7245 5.00018 14.0005 5C14.2764 4.99982 14.5007 4.776 14.5005 4.5V3H17.5005C18.3286 3.00092 18.9996 3.67194 19.0005 4.5V8Z",
    fill: "#CFCFCF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.957fc917be7ac52b25d3268f12950c2c.svg";
export { ForwardRef as ReactComponent };